import { useEffect, useState } from 'react';
import { message } from 'antd';
import ManagerCard from './ManagerCard'
import './Contacts.css'
import { getEmployeesFromLinyuan } from '../../common/javascripts/common.js'

export default function ManagerCards(props) {

  const {lang = 0} = props;
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
      async function load() {
        try {
          const page = await getEmployeesFromLinyuan(1, 100, lang);
          const data = page.list || [];
          const dataOrdered = data.slice().sort((a, b) => Number(a.id) - Number(b.id));
          setDataList(dataOrdered);
        } catch (e) {
          console.error('Error fetching employees from linyuanApi', e);
          const msg = lang === 0 ? '加载联系人失败，请稍后重试' : 'Failed to load contacts, please try again later';
          message.error(msg);
          setDataList([]);
        }
      }
      load();
  }, [lang]);

  return (
    <div className='contacts_cardsContainer'>
      {dataList.map((item) => {
        const { id, avatar, name, location, position, division, products, mobile, email, qrUrl } = item;
        return (
          <ManagerCard 
            key={id}
            lang={lang}
            avatar={avatar} 
            name={name}
            location={location}
            position={position}
            division={division}
            products={products}
            mobile={mobile}
            email={email}
            qrUrl={qrUrl}
          />
        );
      })}
    </div>
  );
}
